import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
let title1 = "";
let title2 = "";
let title3 = "";
let title4 = "";
let title5 = "";
let title7 = "";
let title8 = "";
if (
  localStorage.getItem("consolelanguage") &&
  JSON.parse(localStorage.getItem("consolelanguage")) == "English"
) {
  title1 = "organizationsManagement";
  title2 = "classManagement";
  title3 = "userManagement";
  title4 = "devicemanagement";
  title5 = "homeworkManagement";
  title7 = "BatchImportUser";
  title8 = "EditUser";
} else {
  title1 = "组织管理";
  title2 = "班级管理";
  title3 = "用户管理";
  title4 = "设备管理";
  title5 = "作业管理";
  title7 = "导入用户";
  title8 = "编辑用户";
}
import Layout from "@/layout";
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    redirect: "/schools",
    children: [
      {
        path: "schools",
        name: "schools",
        component: () => import("@/views/schools/index.vue"),
        meta: { title: title1, icon: "form" }
      }
    ]
  },
  {
    path: "/class",
    component: Layout,
    redirect: "/class",
    children: [
      {
        path: "",
        name: "class",
        component: () => import("@/views/class/index.vue"),
        meta: { title: title2, icon: "form" }
      }
    ]
  },
  {
    path: "/user",
    component: Layout,
    redirect: "/user",
    children: [
      {
        path: "",
        name: "User",
        component: () => import("@/views/user/index.vue"),
        meta: { title: title3, icon: "user" }
      }
    ]
  },
  {
    path: "/equipment",
    component: Layout,
    redirect: "/equipment",
    children: [
      {
        path: "",
        name: "Equipment",
        component: () => import("@/views/equipment/index.vue"),
        meta: { title: title4, icon: "dashboard" }
      }
    ]
  },
  {
    path: "/teacher",
    component: Layout,
    redirect: "/teacher",
    children: [
      {
        path: "",
        name: "Teacher",
        component: () => import("@/views/teacher/index.vue"),
        meta: { title: title5, icon: "form" }
      }
    ]
  },
  {
    path: "/batch-import-user",
    component: Layout,
    redirect: "/batch-import-user",
    children: [
      {
        path: "",
        name: "BatchImportUser",
        component: () => import("@/views/batch-import-user/index.vue"),
        meta: { title: title7, icon: "upload" }
      }
    ]
  },
  {
    path: "/edit-user",
    component: Layout,
    redirect: "/edit-user",
    children: [
      {
        path: "",
        name: "EditUser",
        component: () => import("@/views/edit-user/index.vue"),
        meta: { title: title8, icon: "el-icon-edit" }
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    mode: "hash",
    routes: constantRoutes
  });

const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;
